import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import FiberNewIcon from '@material-ui/icons/FiberNew';
import { useStyles } from "../SideDrawer/NavListItems/styles";
import useNotificationFeedbackSettings from "../../hooks/useNotificationFeedbackSettings";
import useDisplayPeriodTimer from "../../hooks/useDisplayPeriodTimer";
import { shouldShowReleaseNotesButton } from "../../utils/notificationFeedbackVisibility";
import clsx from 'clsx';

const ReleaseNotesButton = ({ isIssueValidationOnlyUser }) => {
  const classes = useStyles();
  const { settings, loading, error } = useNotificationFeedbackSettings();

  const isWithinDisplayPeriod = useDisplayPeriodTimer(
    settings?.displayPeriodStart,
    settings?.displayPeriodEnd
  );

  const shouldShow = shouldShowReleaseNotesButton({
    releaseNotesEnabled: settings?.releaseNotesEnabled,
    isWithinDisplayPeriod,
    releaseNotesUrl: settings?.releaseNotesUrl,
    isIssueValidationOnlyUser,
    hasSettings: !loading && !error && settings != null,
  });

  if (!shouldShow) return null;

  const handleClick = () => {
    window.open(settings.releaseNotesUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <ListItem
      button
      className={`${classes.navLink} release-notes-button`}
      onClick={handleClick}
      aria-label="Release Notes"
    >
      <ListItemIcon>
        <FiberNewIcon
          className={clsx("release-notes-icon", classes.releaseNotesIcon)}
          fontSize="large"
        />
      </ListItemIcon>
      <ListItemText primary="What's New" />
    </ListItem>
  );
};

export default ReleaseNotesButton;
